module.exports = __webpack_public_path__ + "static/media/jinyaramen.69e91388.jpg";